import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StatusChipComponent } from "./status-chip.component";
import { SpaceBetweenCapsModule } from "../space-between-caps";

@NgModule({
    declarations: [
        StatusChipComponent
    ],
    imports: [
        CommonModule,
        SpaceBetweenCapsModule
    ],
    exports: [
        StatusChipComponent
    ]
})
export class StatusChipModule { }
